var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRebalancingAndReconstitution = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "42px",
    viewBox: "0 0 38 42",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Available Filters - 01")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Demo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.5.-Index-Builder---Create-New-Methodology---Cards---00",
    transform: "translate(-770.000000, -378.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(297.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(0.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32-Copy",
    transform: "translate(299.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(15.100000, 13.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Geography",
    transform: "translate(152.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Action-/-date_range",
    transform: "translate(0.900000, 0.750000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 50 0 50 50 0 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5833333,22.9166667 L18.75,22.9166667 L18.75,27.0833333 L14.5833333,27.0833333 L14.5833333,22.9166667 Z M43.75,12.5 L43.75,41.6666667 C43.75,43.9583333 41.875,45.8333333 39.5833333,45.8333333 L10.4166667,45.8333333 C8.10416667,45.8333333 6.25,43.9583333 6.25,41.6666667 L6.27083333,12.5 C6.27083333,10.2083333 8.10416667,8.33333333 10.4166667,8.33333333 L12.5,8.33333333 L12.5,4.16666667 L16.6666667,4.16666667 L16.6666667,8.33333333 L33.3333333,8.33333333 L33.3333333,4.16666667 L37.5,4.16666667 L37.5,8.33333333 L39.5833333,8.33333333 C41.875,8.33333333 43.75,10.2083333 43.75,12.5 Z M10.4166667,16.6666667 L39.5833333,16.6666667 L39.5833333,12.5 L10.4166667,12.5 L10.4166667,16.6666667 Z M39.5833333,41.6666667 L39.5833333,20.8333333 L10.4166667,20.8333333 L10.4166667,41.6666667 L39.5833333,41.6666667 Z M31.25,27.0833333 L35.4166667,27.0833333 L35.4166667,22.9166667 L31.25,22.9166667 L31.25,27.0833333 Z M22.9166667,27.0833333 L27.0833333,27.0833333 L27.0833333,22.9166667 L22.9166667,22.9166667 L22.9166667,27.0833333 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  }))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRebalancingAndReconstitution, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rebalancing_and_reconstitution.b26d75b0.svg";
export { ForwardRef as ReactComponent };